/**
 * Captcha Service - Abstraction layer for Google reCAPTCHA Enterprise validation
 */

/**
 * Validate captcha using reCAPTCHA Enterprise invisible widget.
 * Executes silently and puts the token in data.CaptchaInputText.
 *
 * @param {Object} data - Object with siteKey, action, CodigoAnuncio
 * @returns {Promise<Object>} Same data object with CaptchaInputText set to the reCAPTCHA token
 */
function validateCaptcha(data) {
    return new Promise(function(resolve, reject) {
        var siteKey = data.siteKey;
        var action = data.action || 'SOLICITUD';
        grecaptcha.enterprise.ready(async function() {
            try {
                var token = await grecaptcha.enterprise.execute(siteKey, { action: action });
                data.CaptchaInputText = token;
                resolve(data);
            } catch (e) {
                reject(e);
            }
        });
    });
}

// Export for module systems (CommonJS/Node)
if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
        validateCaptcha
    };
}

// Export for global usage (browser/backward compatibility)
if (typeof window !== 'undefined') {
    window.HabitacliaCaptcha = {
        validateCaptcha
    };
}
